import React, { ReactElement } from 'react';
import { FormGroup, Label, Select } from 'idsk-react-components';
import PrispevokVestnika from '../../../../../model/PrispevokVestnika';

interface Props {
  prispevokVestnika: PrispevokVestnika;
}

const DisabledAutorUpdate = ({
  prispevokVestnika,
}: Props): ReactElement => (
  <>
    <FormGroup className="priloha-vestnika-create-form-group__disabled">
      <Label htmlFor="vestnik">Autor príspevku</Label>
      <Select
        id="vestnik"
        width="three-quarters"
        name="vestnikUuid"
        disabled
      >
        <option key={prispevokVestnika.vestnik.uuid} value={prispevokVestnika.vestnik.uuid} hidden>
          {prispevokVestnika.vestnik.skratenyNazov}
        </option>
      </Select>
    </FormGroup>
    <FormGroup className="priloha-vestnika-create-form-group__disabled">
      <Label htmlFor="vestnikDisabled">Vestník</Label>
      <Select
        id="vestnikDisabled"
        width="three-quarters"
        name="vestnikDisabled"
        disabled
      >
        <option key={prispevokVestnika.vestnik.uuid} value={prispevokVestnika.vestnik.uuid} hidden>
          {prispevokVestnika.vestnik.nazov}
        </option>
      </Select>
    </FormGroup>
  </>
);
export default DisabledAutorUpdate;
